// extracted by mini-css-extract-plugin
export var body = "styles-module--body--3f618";
export var container = "styles-module--container--6ae04";
export var content = "styles-module--content--e6ca0";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var layout = "styles-module--layout--664c9";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";
export var textLockup = "styles-module--textLockup--0dc7c";